module.exports = __webpack_public_path__ + "img/interval.b9713cd1.png";